import React from "react";

const DownloadIcon = ({
    width = 40,
    height = 38,
    color = "#E7730A",
    ...rest
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 40 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path d="M38.3633 34H2.36328C1.83285 34 1.32414 34.2107 0.949068 34.5858C0.573995 34.9609 0.363281 35.4696 0.363281 36C0.363281 36.5304 0.573995 37.0391 0.949068 37.4142C1.32414 37.7893 1.83285 38 2.36328 38H38.3633C38.8937 38 39.4024 37.7893 39.7775 37.4142C40.1526 37.0391 40.3633 36.5304 40.3633 36C40.3633 35.4696 40.1526 34.9609 39.7775 34.5858C39.4024 34.2107 38.8937 34 38.3633 34ZM20.3633 0C19.8328 0 19.3241 0.210714 18.9491 0.585786C18.574 0.960859 18.3633 1.46957 18.3633 2V23.18L11.7833 16.58C11.4067 16.2034 10.8959 15.9918 10.3633 15.9918C9.83068 15.9918 9.31989 16.2034 8.94328 16.58C8.56667 16.9566 8.3551 17.4674 8.3551 18C8.3551 18.5326 8.56667 19.0434 8.94328 19.42L18.9433 29.42C19.1292 29.6075 19.3504 29.7562 19.5941 29.8578C19.8378 29.9593 20.0993 30.0116 20.3633 30.0116C20.6273 30.0116 20.8887 29.9593 21.1324 29.8578C21.3762 29.7562 21.5974 29.6075 21.7833 29.42L31.7833 19.42C31.9698 19.2335 32.1177 19.0121 32.2186 18.7685C32.3195 18.5249 32.3715 18.2637 32.3715 18C32.3715 17.7363 32.3195 17.4751 32.2186 17.2315C32.1177 16.9879 31.9698 16.7665 31.7833 16.58C31.5968 16.3935 31.3754 16.2456 31.1318 16.1447C30.8881 16.0438 30.627 15.9918 30.3633 15.9918C30.0996 15.9918 29.8384 16.0438 29.5948 16.1447C29.3511 16.2456 29.1298 16.3935 28.9433 16.58L22.3633 23.18V2C22.3633 1.46957 22.1526 0.960859 21.7775 0.585786C21.4024 0.210714 20.8937 0 20.3633 0Z" fill={color} />
        </svg>
    )
}

export default DownloadIcon;